import { Table } from "@/features/Table";
import { type N1Plans, n1_plans_columns } from "./columns";

import { FilterN1PlansSchema, FilterN1Plans } from "./filter";
import { Tables } from "@/gen/tableNames/tables";
import { Clients } from "@/lib/clients";

export const N1PlansTable = () => {
  return (
    <Table<N1Plans, FilterN1PlansSchema>
      label="Dynamic Data"
      client={Clients.N1}
      table_name={Tables.N1_PLANS}
      columns={n1_plans_columns}
      filter={<FilterN1Plans />}
      actions={[
        {
          label: "actions.new",
          route: `${Clients.N1}/${Tables.N1_PLANS}/new`,
        },
      ]}
    />
  );
};
